(function () {
  if (window.relatedAccessoriesCarouselLoaded) return;
  window.relatedAccessoriesCarouselLoaded = true;

  const selectors = {
    root: '[data-related-accessories-carousel]',
    swiper: '[data-related-accessories-swiper]',
    card: '[data-related-accessory-card]',
    selection: '[data-accessory-selection]',
    optionSelect: '[data-accessory-option-select]',
    swatch: '[data-accessory-option-swatch]',
    optionGroup: '[data-accessory-option-group]',
    variantData: '[data-accessory-variants]',
    addSelectedButton: '[data-accessories-add-selected]',
    addSelectedText: '[data-accessories-add-selected-text]',
    price: '[data-accessory-price]',
    comparePrice: '[data-accessory-compare-price]',
    image: '[data-accessory-image]',
    message: '[data-accessory-message]',
    rootMessage: '[data-accessories-message]',
    prev: '[data-accessories-prev]',
    next: '[data-accessories-next]',
  };

  function initSwiper(root, attempt) {
    const swiperEl = root.querySelector(selectors.swiper);
    if (!swiperEl || swiperEl.swiper) return;

    if (!window.Swiper) {
      if ((attempt || 0) < 20) {
        window.setTimeout(() => initSwiper(root, (attempt || 0) + 1), 100);
      }
      return;
    }

    new Swiper(swiperEl, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      watchOverflow: true,
      loop: true,
      navigation: {
        nextEl: root.querySelector(selectors.next),
        prevEl: root.querySelector(selectors.prev),
      },
      breakpoints: {
        750: {
          slidesPerView: 2.35,
          spaceBetween: 12,
        },
        990: {
          slidesPerView: 3.5,
          spaceBetween: 12,
        },
      },
    });
  }

  function getCardVariants(card) {
    if (card.accessoryVariants) return card.accessoryVariants;

    const variantData = card.querySelector(selectors.variantData);
    if (!variantData) {
      card.accessoryVariants = [];
      return card.accessoryVariants;
    }

    try {
      card.accessoryVariants = JSON.parse(variantData.textContent || '[]');
    } catch (error) {
      card.accessoryVariants = [];
    }

    return card.accessoryVariants;
  }

  function ensureSwatchSelection(card) {
    card.querySelectorAll(selectors.optionGroup).forEach((group) => {
      const swatches = Array.from(group.querySelectorAll(selectors.swatch));
      if (!swatches.length || swatches.some((swatch) => swatch.classList.contains('is-selected'))) return;

      swatches[0].classList.add('is-selected');
      swatches[0].setAttribute('aria-pressed', 'true');
    });
  }

  function getSelectedOptions(card) {
    const selectedOptions = [];

    card.querySelectorAll(selectors.optionSelect).forEach((select) => {
      const position = Number(select.dataset.optionPosition || 1) - 1;
      selectedOptions[position] = select.value;
    });

    card.querySelectorAll(`${selectors.swatch}.is-selected`).forEach((swatch) => {
      const position = Number(swatch.dataset.optionPosition || 1) - 1;
      selectedOptions[position] = swatch.dataset.optionValue;
    });

    return selectedOptions;
  }

  function toFiniteNumber(value) {
    if (value === null || value === undefined || value === '') return null;

    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function getVariantCartQuantity(variant) {
    const quantity = toFiniteNumber(variant?.cartQuantity);
    return quantity === null ? 0 : Math.max(quantity, 0);
  }

  function getVariantQuantityLimit(variant) {
    if (!variant) return null;

    const limits = [];
    const quantityRuleMax = toFiniteNumber(variant.quantityRuleMax);
    const inventoryQuantity = toFiniteNumber(variant.inventoryQuantity);

    if (quantityRuleMax !== null) limits.push(quantityRuleMax);
    if (variant.tracksInventory && inventoryQuantity !== null) limits.push(Math.max(inventoryQuantity, 0));

    return limits.length ? Math.min(...limits) : null;
  }

  function getVariantRemainingQuantity(variant) {
    const limit = getVariantQuantityLimit(variant);
    if (limit === null) return null;

    return Math.max(limit - getVariantCartQuantity(variant), 0);
  }

  function canAddVariant(variant) {
    if (!variant || !variant.available) return false;

    const remainingQuantity = getVariantRemainingQuantity(variant);
    return remainingQuantity === null || remainingQuantity > 0;
  }

  function stripHtml(html) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html || '';
    return wrapper.textContent || wrapper.innerText || '';
  }

  function getQuantityLimitMessage(variant) {
    const limit = getVariantQuantityLimit(variant);

    if (window.cartStrings?.quantityError && limit !== null) {
      return stripHtml(window.cartStrings.quantityError.replace('[quantity]', limit));
    }

    return 'This item has reached the maximum quantity in your cart.';
  }

  function variantMatchesOptions(variant, selectedOptions) {
    return selectedOptions.every((value, index) => {
      if (!value) return true;
      return String(variant[`option${index + 1}`] || '') === String(value);
    });
  }

  function findSelectedVariant(card) {
    const variants = getCardVariants(card);
    const selectedOptions = getSelectedOptions(card);
    const availableVariant = variants.find((variant) => variantMatchesOptions(variant, selectedOptions) && variant.available);

    return availableVariant || variants.find((variant) => variantMatchesOptions(variant, selectedOptions)) || null;
  }

  function showMessage(card, text, isError) {
    const message = card.querySelector(selectors.message);
    if (!message) return;

    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
  }

  function showRootMessage(root, text, isError) {
    const message = root.querySelector(selectors.rootMessage);
    if (!message) return;

    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
  }

  function updateRootSelectionState(root) {
    if (!root) return;

    const button = root.querySelector(selectors.addSelectedButton);
    if (!button) return;

    const isAdding = root.dataset.accessoriesAdding === 'true';
    const selectedCount = Array.from(root.querySelectorAll(selectors.selection)).filter((selection) => {
      if (!selection.checked) return false;
      return isAdding || !selection.disabled;
    }).length;
    const labelText = button.querySelector(selectors.addSelectedText);
    const baseLabel = selectedCount > 0
      ? button.dataset.labelSelected || 'Add Selected Items'
      : button.dataset.labelEmpty || 'Add Selected Items';
    const buttonText = selectedCount > 0 ? `${selectedCount} ${baseLabel}` : baseLabel;

    if (labelText) labelText.textContent = buttonText;
    button.setAttribute('aria-label', buttonText);
    button.disabled = isAdding || selectedCount === 0;
    if (button.disabled) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function updateCardFromControls(card) {
    if (!card) return;

    ensureSwatchSelection(card);

    const variant = findSelectedVariant(card);
    const selection = card.querySelector(selectors.selection);
    const price = card.querySelector(selectors.price);
    const comparePrice = card.querySelector(selectors.comparePrice);
    const image = card.querySelector(selectors.image);
    const root = card.closest(selectors.root);
    const isAdding = root?.dataset.accessoriesAdding === 'true';
    const available = canAddVariant(variant);
    const isAtQuantityLimit = Boolean(variant && variant.available && getVariantRemainingQuantity(variant) === 0);

    if (selection) {
      selection.dataset.variantId = variant?.id || '';
      selection.dataset.accessoryAvailable = available ? 'true' : 'false';
      selection.disabled = isAdding || !available;
      if (selection.disabled) {
        selection.setAttribute('aria-disabled', 'true');
      } else {
        selection.removeAttribute('aria-disabled');
      }
      if (!available) selection.checked = false;
    }

    if (price && variant?.price) {
      price.textContent = variant.price;
    }

    if (comparePrice) {
      comparePrice.textContent = variant?.comparePrice || '';
      comparePrice.hidden = !variant?.comparePrice;
    }

    if (image && variant?.image && image.getAttribute('src') !== variant.image) {
      image.style.opacity = '0';
      window.setTimeout(() => {
        image.setAttribute('src', variant.image);
        image.removeAttribute('srcset');
        image.style.opacity = '1';
      }, 120);
    }

    showMessage(card, isAtQuantityLimit ? getQuantityLimitMessage(variant) : '', isAtQuantityLimit);
    updateRootSelectionState(root);
  }

  function selectSwatch(button) {
    const group = button.closest(selectors.optionGroup);
    const card = button.closest(selectors.card);
    if (!group || !card) return;

    group.querySelectorAll(selectors.swatch).forEach((swatch) => {
      const isSelected = swatch === button;
      swatch.classList.toggle('is-selected', isSelected);
      swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    updateCardFromControls(card);
  }

  function setRootLoading(root, isLoading) {
    const button = root.querySelector(selectors.addSelectedButton);
    if (!button) return;

    root.dataset.accessoriesAdding = isLoading ? 'true' : 'false';
    button.classList.toggle('loading', isLoading);

    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);

    root.querySelectorAll(selectors.card).forEach((card) => {
      updateCardFromControls(card);
    });

    updateRootSelectionState(root);
  }

  function getCartElement() {
    return document.querySelector('cart-popup') || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getCartPopupLoader() {
    if (!window.CartPopupLoader || typeof window.CartPopupLoader.renderResponse !== 'function') return null;

    return window.CartPopupLoader;
  }

  function getCartSectionsToRender(cart) {
    const cartPopupLoader = getCartPopupLoader();
    if (cartPopupLoader && typeof cartPopupLoader.getSectionsToRender === 'function') {
      return cartPopupLoader.getSectionsToRender();
    }

    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];

    return cart.getSectionsToRender().map((section) => section.id || section.section).filter(Boolean);
  }

  function getCartAddUrl() {
    const cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
  }

  function getCartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  function getCartErrorMessage(parsedState) {
    if (parsedState?.status === 429) {
      return 'Please wait a moment before adding another item.';
    }

    const error = parsedState?.description || parsedState?.message || parsedState?.errors;

    if (typeof error === 'string') return error;
    if (Array.isArray(error)) return error.join(' ');
    if (error && typeof error === 'object') {
      return Object.values(error).flat().join(' ');
    }

    return window.cartStrings?.error || 'Unable to add item.';
  }

  async function renderCartContents(cart, parsedState, trigger) {
    const cartPopupLoader = getCartPopupLoader();
    if (cartPopupLoader) {
      try {
        return await cartPopupLoader.renderResponse(parsedState, {
          trigger,
          shouldOpen: true,
        });
      } catch (error) {
        console.error(error);
      }
    }

    if (!cart || typeof cart.renderContents !== 'function') return false;

    try {
      if (parsedState.sections) {
        cart.renderContents(parsedState, true);
        return true;
      }
    } catch (error) {
      console.error(error);
    }

    if (typeof cart.refresh === 'function') {
      try {
        await cart.refresh();
        return true;
      } catch (error) {
        console.error(error);
      }
    }

    return false;
  }

  async function parseCartJson(response) {
    const text = await response.text();

    try {
      return JSON.parse(text);
    } catch (error) {
      if (response.status === 429) {
        return {
          status: 429,
          description: 'Please wait a moment before adding another item.',
        };
      }

      throw new Error(window.cartStrings?.error || 'Unable to update cart.');
    }
  }

  function getQuantityFromCartState(cartData, variantId, fallbackQuantity) {
    if (!cartData) return fallbackQuantity;

    if (Array.isArray(cartData.items)) {
      const matchingItems = cartData.items.filter((item) => String(item.variant_id || item.id) === String(variantId));
      if (matchingItems.length) {
        return matchingItems.reduce((total, item) => total + (toFiniteNumber(item.quantity) || 0), 0);
      }

      return fallbackQuantity;
    }

    if (String(cartData.variant_id || cartData.id) === String(variantId)) {
      return toFiniteNumber(cartData.quantity) ?? fallbackQuantity;
    }

    return fallbackQuantity;
  }

  function syncVariantCartQuantity(scope, variantId, quantity) {
    const root = scope?.closest?.(selectors.root) || scope || document;
    const nextQuantity = Math.max(toFiniteNumber(quantity) ?? 0, 0);

    root.querySelectorAll(selectors.card).forEach((card) => {
      let hasVariant = false;

      getCardVariants(card).forEach((variant) => {
        if (String(variant.id) !== String(variantId)) return;
        variant.cartQuantity = nextQuantity;
        hasVariant = true;
      });

      if (hasVariant) updateCardFromControls(card);
    });
  }

  function collectSelectedLineItems(root) {
    const groups = new Map();

    root.querySelectorAll(selectors.card).forEach((card) => {
      const selection = card.querySelector(selectors.selection);
      if (!selection || !selection.checked || selection.disabled) return;

      const variant = findSelectedVariant(card);
      if (!canAddVariant(variant)) {
        selection.checked = false;
        updateCardFromControls(card);
        return;
      }

      const key = String(variant.id);
      const existing = groups.get(key);
      const currentQuantity = existing ? existing.quantity : 0;
      const remainingQuantity = getVariantRemainingQuantity(variant);

      if (remainingQuantity !== null && currentQuantity + 1 > remainingQuantity) {
        selection.checked = false;
        showMessage(card, getQuantityLimitMessage(variant), true);
        return;
      }

      if (existing) {
        existing.quantity += 1;
        existing.cards.push(card);
      } else {
        groups.set(key, {
          id: variant.id,
          quantity: 1,
          variant,
          cards: [card],
        });
      }
    });

    return Array.from(groups.values());
  }

  function syncAddedQuantities(root, groups, parsedState) {
    groups.forEach((group) => {
      const fallbackQuantity = getVariantCartQuantity(group.variant) + group.quantity;
      const updatedQuantity = Math.max(getQuantityFromCartState(parsedState, group.id, fallbackQuantity), fallbackQuantity);
      syncVariantCartQuantity(root, group.id, updatedQuantity);
    });
  }

  async function addSelectedAccessories(root, trigger) {
    if (!root || root.dataset.accessoriesAdding === 'true') return;

    const button = root.querySelector(selectors.addSelectedButton);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const groups = collectSelectedLineItems(root);
    const items = groups.map((group) => ({
      id: group.id,
      quantity: group.quantity,
    }));
    const totalQuantity = groups.reduce((total, group) => total + group.quantity, 0);

    updateRootSelectionState(root);

    if (!items.length) {
      showRootMessage(root, 'Select at least one available item.', true);
      return;
    }

    const cart = getCartElement();
    const sectionIds = getCartSectionsToRender(cart);
    const body = { items };

    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
      if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
    }

    showRootMessage(root, '', false);
    root.querySelectorAll(selectors.message).forEach((message) => {
      message.textContent = '';
      message.classList.remove('is-error');
    });
    setRootLoading(root, true);

    try {
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
      };

      config.headers = config.headers || {};
      config.headers['Content-Type'] = 'application/json';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(body);

      const response = await fetch(getCartAddUrl(), config);
      const parsedState = await parseCartJson(response);

      if (!response.ok || parsedState.status) {
        throw new Error(getCartErrorMessage(parsedState));
      }

      syncAddedQuantities(root, groups, parsedState);

      const didRenderCart = await renderCartContents(cart, parsedState, trigger);
      if (!didRenderCart) {
        window.location = getCartUrl();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'related-accessories-carousel',
            productVariantId: groups[0]?.id,
            productVariantIds: groups.map((group) => group.id),
            cartData: parsedState,
          });
        } catch (publishError) {
          console.error(publishError);
        }
      }

      showRootMessage(root, `${totalQuantity} ${totalQuantity === 1 ? 'item' : 'items'} added.`, false);
    } catch (error) {
      showRootMessage(root, error.message || window.cartStrings?.error || 'Unable to add item.', true);
    } finally {
      setRootLoading(root, false);
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.relatedAccessoriesInitialized === 'true') return;
    root.dataset.relatedAccessoriesInitialized = 'true';

    initSwiper(root);

    root.querySelectorAll(selectors.card).forEach((card) => {
      updateCardFromControls(card);
    });
    updateRootSelectionState(root);

    root.addEventListener('change', (event) => {
      const selection = event.target.closest(selectors.selection);
      if (selection && root.contains(selection)) {
        showRootMessage(root, '', false);
        updateRootSelectionState(root);
        return;
      }

      const select = event.target.closest(selectors.optionSelect);
      if (!select || !root.contains(select)) return;
      updateCardFromControls(select.closest(selectors.card));
    });

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest(selectors.swatch);
      if (swatch && root.contains(swatch)) {
        selectSwatch(swatch);
        return;
      }

      const button = event.target.closest(selectors.addSelectedButton);
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      addSelectedAccessories(root, button);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(selectors.root).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
